import { render, staticRenderFns } from "./SidebarDefault.vue?vue&type=template&id=6432e338&scoped=true"
import script from "./SidebarDefault.vue?vue&type=script&lang=js"
export * from "./SidebarDefault.vue?vue&type=script&lang=js"
import style0 from "./SidebarDefault.vue?vue&type=style&index=0&id=6432e338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6432e338",
  null
  
)

export default component.exports